import { pure } from 'recompose';
export default pure;